import { get, postJson, post, uploadFile } from '@/api/request/CommonRequest'
import axios from 'axios'
import { Message, Modal } from 'view-design'
import qs from 'qs'
import { getToken } from '@/utils/auth'  // 添加这一行
export let fileMethod = {}



/**
 * 上传文件（完整流程：上传 + 插入记录）
 * 对应 POST /api/file/upload
 */
 

/**
 * 上传文件（完整流程：上传 + 插入记录）
 * 对应 POST /api/file/upload
 */
fileMethod.uploadFile = function (file, father_table, father_id, type_1, type_2, bz) {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('father_table', father_table)
  formData.append('father_id', father_id)
  if (type_1) formData.append('type_1', type_1)
  if (type_2) formData.append('type_2', type_2)
  if (bz) formData.append('bz', bz)
  // 使用 uploadFile 方法，而不是 post
  return uploadFile('/api/file/upload', formData)
}


/**
 * 查询文件列表
 * 对应 POST /api/file/list
 */
fileMethod.listFiles = function (father_table, father_id, type_1, type_2) {
  return post('/api/file/list', {
    father_table: father_table,
    father_id: String(father_id),  // ← 强制转为字符串
    type_1: type_1 || '',
    type_2: type_2 || ''
  })
}

/**
 * 删除文件
 * 对应 POST /api/file/delete
 */
fileMethod.deleteFile = function (id) {
  return post('/api/file/delete', { id: id })
}

/**
 * 下载文件（返回 Blob）
 * 对应 GET /api/file/download
 */
fileMethod.downloadFile = function (filePath) {
  return axios({
    method: 'get',
    url: '/nngy/api/file/download',  // 完整路径
    params: { filePath: filePath },
    responseType: 'blob',
    headers: {
      'Authorization': 'Bearer ' + getToken()
    }
  })
}

/**
 * 上传文件（仅上传，不插入记录）
 * 返回文件信息供前端自行处理
 */
fileMethod.uploadOnly = function (file) {
  const formData = new FormData()
  formData.append('file', file)
  return uploadFile('/api/file/uploadOnly', formData)
}


// ========== 旧接口（保留兼容） ==========

/**
 * 旧接口：上传文件（仅上传，不插入记录）
 * 对应 POST /api/file/uploadHouseFiles
 */
fileMethod.uploadHouseFiles = function (file) {
  const formData = new FormData()
  formData.append('file', file)
  return post('/api/file/uploadHouseFiles', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 旧接口：插入文件记录
 * 对应 POST /api/file/insertFileRecord
 */
fileMethod.insertFileRecord = function (params) {
  return post('/api/file/insertFileRecord', params)
}

/**
 * 旧接口：查询文件列表
 * 对应 POST /api/file/selectFiles
 */
fileMethod.selectFiles = function (params) {
  return post('/api/file/selectFiles', params)
}

/**
 * 旧接口：微信小程序查询文件
 * 对应 POST /api/file/selectFilesForWechat
 */
fileMethod.selectFilesForWechat = function (params) {
  return post('/api/file/selectFilesForWechat', params)
}

/**
 * 旧接口：微信小程序插入文件记录
 * 对应 POST /api/file/insertWechatFileRecord
 */
fileMethod.insertWechatFileRecord = function (params) {
  return post('/api/file/insertWechatFileRecord', params)
}

/**
 * 旧接口：微信小程序删除文件
 * 对应 POST /api/file/deleteWechatFile
 */
fileMethod.deleteWechatFile = function (params) {
  return post('/api/file/deleteWechatFile', params)
}